import { render, staticRenderFns } from "./PublishVideoInspectionKitDialog.vue?vue&type=template&id=6ecb2db2"
import script from "./PublishVideoInspectionKitDialog.vue?vue&type=script&lang=js"
export * from "./PublishVideoInspectionKitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports